export default "__VITE_ASSET__b94c4a08__"